<script lang="ts">
  export let message: string = "";
  export let isHidden: boolean = true;
</script>

{#if !isHidden }
  <div class="search-status-message mt-3">
    <p class="fw-bold">{message}</p>
  </div>
{/if}
